<template>
  <div class="routerInfo">


    <div class="container-fluid container-panel container-mainblock">
      <div class="container">
        <div class="container-head">
          <div class="mainblock-left">
            <i class="fas fa-book mainblock-icon"></i>
            <a  class="mainblock-label">资料学习</a>
          </div>
          <div class="mainblock-right">
            <a  class="mainblock-more" @click="toNewsList()">查看更多</a>
          </div>
        </div>
        <div class="container-body" style="display: flex">
          <div  style="flex: 1">
            <el-carousel :interval="5000" arrow="always">
              <el-carousel-item v-for="item in scrollList" :key="item">
                <img @click="toDeatail(item.newsId)" style="width:100%;height:100%;object-fit: fill" :src="url+item.titleImage"/>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="party-block" style="flex: 1">
            <ul >
              <li v-for="news in newsList" @click="toDeatail(news.dataId)">
                <div >{{news.title}}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid container-panel container-mainblock">
      <div class="container">
        <div class="container-head">
          <div class="mainblock-left">
            <i class="fas fa-cubes mainblock-icon"></i>
            <a  class="mainblock-label">视频课程</a>
          </div>
          <div class="mainblock-right">
            <a class="mainblock-more" @click="toVideoList()">查看更多</a>
          </div>
        </div>
        <div class="container-body">
          <ul class="panel-course" id="videoContainer">
            <li v-for="topic in videoList">
              <a target="_blank" class="card-course" @click="toVideoDeatail(topic.dataId)">
                <div class="card-course-top">
                  <img :src="url+topic.coverUrl"/>
                </div>
                <div class="card-course-name">{{topic.title}}</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>





    <div class="container-fluid container-panel container-mainblock">
      <div class="container">
        <div class="container-head">
          <div class="mainblock-left">
            <i class="fas fa-cubes mainblock-icon"></i>
            <a  class="mainblock-label">视频专题</a>
          </div>
          <div class="mainblock-right">
            <a class="mainblock-more"  @click="toTopicList()">查看更多</a>
          </div>
        </div>
        <div class="container-body">
          <ul class="panel-course" id="topicContainer">
            <li v-for="topic in topicList">
              <a target="_blank" class="card-course" @click="toTopicDetail(topic.dataId)">
                <div class="card-course-top">
                  <img :src="url+topic.coverUrl"/>
                </div>
                <div class="card-course-name">{{topic.title}}</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style rel='stylesheet/less' lang='less' scoped>
@import "../../assets/less/variables.less";
@import "../../assets/less/mySearch.less";
@import "../../assets/less/style.less";

</style>

<script type="text/ecmascript-6">
import viewFunction from "../../assets/js/viewFunction";
import { mapState, mapGetters ,mapMutations} from 'vuex'

export default {
  name: 'Training',
  inject:['check','changeActiveIndex'],
  data(){
    return {
      topicList: [],
      videoList: [],
      newsList: [],
      scrollList: [],
      //url:'http://121.89.210.255:8080/jinneng/'
      //url:'https://www.jnjtzxpx.com/jinneng/'
      url:'https://www.jnjtzxpx.com/jinnengApi/'

    }
  },
  mounted() {

    this.findNewsLit()
    this.findScrollNews()
    this.findVideoLit()
    this.findTopicLit()
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    ...mapGetters({
      navigationList: 'navs'
    })
  },
  methods:{
    findNewsLit(){
      var params = {
        pageNum:1,
        pageSize: 10
      }
      let url = '/api/newsView/findNewsList'
      let that = this
      this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
        that.newsList = res.data
      }))
    },
    findScrollNews(){
      var params = {
        pageNum:1,
        pageSize: 10
      }
      let url = '/api/newsView/findScrollNews'
      let that = this
      this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
        that.scrollList = res.data
      }))
    },
    recv(){
      this.check();
    },
    findVideoLit(){
      var params = {
        pageNum:1,
        pageSize: 15
      }
      let url = '/api/newsView/findVideoList'
      let that = this
      this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
        that.videoList = res.data
      }))
    },
    findTopicLit(){
      var params = {
        module: "[6,12]",
        pageNum:1,
        pageSize: 10
      }
      let url = '/api/newsView/findTopicList'
      let that = this
      this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
        that.topicList = res.data
      }))
    },
    toNewsList (){
      this.check()
      this.changeActiveIndex('NewsList')
      this.$router.push({
        path:'/NewsList',
      })
    },
    toDeatail(newsId){

      let user = this.user
      if (user== null){
        this.check()
      }else {
        this.$router.push({
          path:'/NewsDetail',
          query:{
            newsId:newsId
          }
        })
      }

    },
    toVideoList(){

      let user = this.user
      if (user== null){
        this.check()
      }else {
        this.$router.push({
          path:'/VideoList',
        })
      }

    },
    toVideoDeatail(newsId){

      let user = this.user
      if (user== null){
        this.check()
      }else {
        this.$router.push({
          path:'/VideoDetail',
          query:{
            videoNewsId:newsId
          }
        })
      }

    },
    toTopicList(){

      let user = this.user
      if (user== null){
        this.check()
      }else {
        this.$router.push({
          path:'/TopicList',

        })
      }
    },
    toTopicDetail(topicId){
      let user = this.user
      if (user== null){
        this.check()
      }else {
        this.$router.push({
          path:'/TopicVideoList',
          query:{
            topicId:topicId
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/learn/Index.vue